import { themeVars } from '../theme/vars';
import { borderRadius, boxShadows, space } from '../tokens';
import { typography } from '../typography';
import {
  fadeIn,
  slideInFromBottom,
  slideInFromLeft,
  slideInFromRight,
  slideInFromTop,
} from '../animations.css';
import { globalStyle, style } from '../layer.css';

export const dropdownMenuContent = style({
  overflowY: 'auto',
  overflowX: 'hidden',
  overscrollBehavior: 'contain',

  backgroundColor: themeVars.container.primary.background.idle,

  maxHeight: `min(var(--radix-dropdown-menu-content-available-height), 600px)`,
  paddingTop: space.s4,
  paddingBottom: space.s4,
  minWidth: 160,
  boxShadow: boxShadows.default,
  borderRadius: borderRadius.r8,
  outline: `1px solid ${themeVars.container.border.default} !important`, // radix overwrites outline with inline styles
  outlineOffset: '-1px',
  willChange: 'transform, opacity',
  animationDuration: '400ms',
  animationTimingFunction: 'cubic-bezier(0.16, 1, 0.3, 1)',
  animationFillMode: 'forwards',

  selectors: {
    '&[data-state="open"][data-side="top"]': {
      animationName: `${slideInFromBottom}, ${fadeIn}`,
    },
    '&[data-state="open"][data-side="right"]': {
      animationName: `${slideInFromLeft}, ${fadeIn}`,
    },
    '&[data-state="open"][data-side="bottom"]': {
      animationName: `${slideInFromTop}, ${fadeIn}`,
    },
    '&[data-state="open"][data-side="left"]': {
      animationName: `${slideInFromRight}, ${fadeIn}`,
    },
  },
});

export const dropdownMenuItem = style({
  cursor: 'pointer',
  ...typography['labelMd'],
  display: 'flex',
  alignItems: 'center',
  gap: space.s12,
  padding: `${space.s8}px ${space.s12}px`,
  minHeight: 34,
  outline: 'none',
  userSelect: 'none',

  margin: `0 ${space.s4}px`,
  borderRadius: borderRadius.r4,

  backgroundColor: themeVars.dropdownMenu.background.default,

  selectors: {
    '&[data-highlighted]': {
      backgroundColor: themeVars.dropdownMenu.background.hover,
    },

    '&:active': {
      backgroundColor: themeVars.dropdownMenu.background.active,
    },

    '&:disabled,&[data-disabled]': {
      color: themeVars.dropdownMenu.foreground.disabled,
      pointerEvents: 'none',
    },
  },
});

globalStyle(`.${dropdownMenuItem} :where(svg)`, {
  width: '20px',
  height: '20px',
});

export const criticalDropdownItem = style([
  {
    selectors: {
      '&:is(&)': {
        color: themeVars.container.foreground.critical,
      },
    },
  },
]);

export const dropdownMenuSeparator = style({
  height: 1,
  margin: `${space.s4}px 0`,
  backgroundColor: themeVars.container.border.default,
});

export const dropdownMenuItemIndicator = style({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  marginLeft: 'auto',
});
globalStyle(`.${dropdownMenuItemIndicator} :where(svg)`, {
  width: '20px',
  height: '20px',
});

export const dropdownMenuItemRightIcon = style({
  marginLeft: 'auto',
});
